export default __webpack_public_path__ + "static/media/coffee_grinders.80243139.png";